import { blue } from "@ant-design/colors";
import styled from "styled-components";

export const StyledCustomerDashboardHeader = styled.div`
  width: 100%;
  height: 100%;
  // min-height: 200px;
  // background-color: ${() => blue[6]};
  // padding: 15px 10px;
  padding-bottom: 10px;
`;
